











































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import DxDropDownBox from "devextreme-vue/drop-down-box";
import {
  DxDataGrid,
  DxSelection,
  DxPaging,
  DxFilterRow,
  DxScrolling,
  DxSearchPanel,
} from "devextreme-vue/data-grid";
import { centros } from "@/shared/dtos/centros";
import centrosModule from "@/store/modules/centros-module";
import { UtilsString } from "@/utils/utils-string";
import TableSelectSingle from "@/components/DataTableSelect/TableSelectSingle.vue";

declare global {
  interface Window {
    google: any;
  }
}

interface GoogleMapMarker {
  position: {
    lat: number;
    lng: number;
  };
  info: any;
  nombre: string;
  id: number;
  direccion?: string;
  colorRuta?: string;
  type?: "start" | "end" | "hotel" | "center";
}

interface RutaCache {
  StartAddress: string;
  EndAddress: string;
  StartLat: number;
  StartLng: number;
  EndLat: number;
  EndLng: number;
  DistanciaMetros: number;
  DuracionSegundos: number;
}

interface PuntoRuta {
  nombre: string;
  direccion?: string;
  posicion: string;
  type: "start" | "center" | "hotel" | "end";
  distanciaAlSiguiente?: number;
  tiempoAlSiguiente?: number;
  lat: number;
  lng: number;
  id_centro: number;
  siguiente?: PuntoRuta; // Nuevo campo para el siguiente centro
  colorRuta?: string; // Color de la ruta
}

interface DayPlan {
  day: string;
  centers: PuntoRuta[];
  expanded: boolean;
  travelTimeToFirstCenter?: number;
  distanciaAlPrimerCentro?: number;
  tiempoTotalDia?: number; // tiempo total del día en minutos
  hotel?: {
    name: string;
    address: string;
    price: number;
    mapUrl: string;
  };
}

interface Hotel {
  name: string;
  address: string;
  price: number;
  mapUrl: string;
}

@Component({
  components: {
    DxDropDownBox,
    DxDataGrid,
    DxSelection,
    DxPaging,
    DxFilterRow,
    DxScrolling,
    DxSearchPanel,
    TableSelectSingle,
  },
})
export default class PlanificadorRutasCompleto extends Vue {
  // Configuración del mapa
  public center = { lat: 39.399548026808425, lng: -0.4157916279543559 };
  public zoom = 6.5;
  public valid = false;
  public loading = false;
  public ApiKey = "AIzaSyAEUBxJrwmT_yP1Udl7-7_t3vlS8mrV1t0";

  // Configuración de ruta
  public startLocation: { lat: number; lng: number } | null = null;
  public endLocation: { lat: number; lng: number } | null = null;
  public startLocationName = "";
  public endLocationName = "";
  public customMarkers: GoogleMapMarker[] = [];
  public selectedCentros: number[] = [];
  public selectedCentros_DropDown: any[] = [];
  public tiempoLimpiezaCentro: number = 2.5; // en horas (media hora por defecto)

  public rutaColors: string[] = [
    "#1e88e5", // Azul
    "#43a047", // Verde
    "#ff9900", // Naranja
    "#8e24aa", // Violeta
    "#fb8c00", // Ámbar
    "#3949ab", // Azul intenso
    "#d81b60", // Rosa fuerte
  ];
  public tituloPopUp = "Selecciona un centro";

  public maxSelectedCenters = 23; // Número máximo de centros seleccionables

  // Configuración de vehículo
  public consumoGasolina = 7;
  public precioGasolina = 1.5;

  // Resultados
  public rutaCalculada = false;
  //public routePlan: DayPlan[] = [];

  public routePlans: DayPlan[][] = [];

  public routePlan_edit: DayPlan = {
    day: "",
    centers: [],
    expanded: false,
  };
  public planificacion_nombre = "";

  // Ventana de información
  public infoWindowOpened = false;
  public infoWindowOptions = { pixelOffset: { width: 0, height: -30 } };
  public infoWindowPosition: { lat: number; lng: number } | null = null;
  public infoWindowContent: { nombre?: string; direccion?: string } = {};
  public timeoutCerrarInfo: ReturnType<typeof setTimeout> | null = null;
  // Notificaciones
  public snackbar = {
    show: false,
    text: "",
    color: "success",
  };

  // Reglas de validación
  public requiredRules = [(v: string) => !!v || "Este campo es obligatorio"];
  public positiveNumberRules = [(v: number) => v > 0 || "Debe ser positivo"];

  async created() {
    await centrosModule.getcentroses();
    this.OpenEditForm();
    /*
    this.selectedCentros = [
      1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
      22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39,
      40, 41, 42,
    ];
    this.startLocation = {
      lat: 39.2638755,
      lng: -0.4702895,
    };
    this.endLocation = {
      lat: 39.2638755,
      lng: -0.4702895,
    };
    this.startLocationName = "Alginet";
    this.endLocationName = "Alginet";

    centrosModule.GetRuta(8).then((res: any) => {
      if (res) {
        const data = res;
        this.routePlans = data.Planes.map((ruta: any[], index: number) =>
          ruta.map((dia: any) => {
            return {
              day: dia.Dia,
              tiempoTotalDia: dia.TiempoTotalDia,
              Hotel: dia.Hotel,
              centers: dia.Centros.map((centro: any) => ({
                nombre: centro.Nombre,
                direccion: centro.Direccion,
                lat: centro.Lat,
                lng: centro.Lng,
                posicion: {
                  lat: centro.Lat,
                  lng: centro.Lng,
                },
                id_centro: centro.IdCentro,
                distanciaAlSiguiente: centro.DistanciaAlSiguiente,
                tiempoAlSiguiente: centro.TiempoAlSiguiente,
                type: centro.Tipo,
                siguiente: centro.Siguiente || null,
                colorRuta: index + 1, //colorRuta || null,
              })),
              expanded: false, // estado inicial en Vue
            };
          })
        );
      }
    });
    this.rutaCalculada = true;
    this.setStartLocation(this.startLocation);
    this.setEndLocation(this.endLocation);*/
  }

  // Propiedades computadas
  get centrosOptions() {
    return centrosModule.centroses;
  }

  get filteredCentrosOptions() {
    return this.centrosOptions.filter(
      (center) =>
        !this.selectedCentros.includes(center.id) ||
        this.selectedCentros_DropDown.some(
          (selected: any) => selected.id === center.id
        )
    );
  }

  get markers(): GoogleMapMarker[] {
    return this.centrosOptions.map((x: centros) => ({
      position: {
        lat: Number.parseFloat(x.latitud.replace(",", ".")),
        lng: Number.parseFloat(x.longitud.replace(",", ".")),
      },
      info: x.toJson(),
      nombre: x.nombre,
      direccion: x.direccion,
      id: x.id,
      type: "center",
    }));
  }

  /*get filteredMarkers(): GoogleMapMarker[] {
    let result: GoogleMapMarker[] = this.markers.filter((marker) =>
      this.selectedCentros.includes(marker.id)
    );
    return [...result, ...this.customMarkers];
  }*/
  get filteredMarkers(): GoogleMapMarker[] {
    const marcadores: GoogleMapMarker[] = [];

    for (const plan of this.routePlans) {
      for (const day of plan) {
        for (const punto of day.centers) {
          // Buscar el marcador original asociado
          const baseMarker = this.markers.find((m) => m.id === punto.id_centro);
          if (baseMarker) {
            marcadores.push({
              ...baseMarker,
              type: punto.type,
              colorRuta: punto.colorRuta,
            });
          }
        }
      }
    }

    // Incluir también los personalizados (inicio y fin)
    return [...marcadores, ...this.customMarkers];
  }

  get costoGasolina() {
    return (
      (this.distanciaTotal / 1000) *
      (this.consumoGasolina / 100) *
      this.precioGasolina
    );
  }
  get distanciaTotal(): number {
    return this.routePlans
      .flatMap((route) => route) // Flatten cada routePlan
      .flatMap((day) => day.centers)
      .reduce((total, center) => total + (center.distanciaAlSiguiente || 0), 0);
  }

  get tiempoTotal(): number {
    return this.routePlans
      .flatMap((route) => route)
      .flatMap((day) => day.centers)
      .reduce((total, center) => total + (center.tiempoAlSiguiente || 0), 0);
  }

  get tiempoLimpiezaTotal(): number {
    const totalCentros = this.routePlans
      .flatMap((route) => route)
      .flatMap((day) => day.centers.filter((c) => c.type === "center")).length;
    return totalCentros * this.tiempoLimpiezaCentro * 3600; // en segundos
  }

  get tiempoTotalCombinado(): number {
    return this.tiempoTotal + this.tiempoLimpiezaTotal;
  }
  // Resumen para múltiples DayPlan
  getResumenRuta(planDia: DayPlan | DayPlan[]) {
    const planes = Array.isArray(planDia) ? planDia : [planDia];

    let limpieza = 0;
    let conduccion = 0;
    let distancia = 0;

    for (const d of planes) {
      const resumen = this.getResumenRutaDeUnDia(d);
      limpieza += resumen.limpieza;
      conduccion += resumen.conduccion;
      distancia += resumen.distancia;
    }

    const gasolina =
      (distancia / 1000) * (this.consumoGasolina / 100) * this.precioGasolina;

    return {
      limpieza,
      conduccion,
      total: limpieza + conduccion,
      distancia,
      gasolina,
    };
  }

  // Resumen para un solo DayPlan
  getResumenRutaDeUnDia(d: DayPlan) {
    const limpieza =
      d.centers.filter((c) => c.type === "center").length *
      this.tiempoLimpiezaCentro *
      3600;

    const conduccion =
      d.centers.reduce((sum, c) => sum + (c.tiempoAlSiguiente || 0), 0) +
      (d.travelTimeToFirstCenter || 0);

    const distancia =
      d.centers.reduce((sum, c) => sum + (c.distanciaAlSiguiente || 0), 0) +
      (d.distanciaAlPrimerCentro || 0);

    const gasolina =
      (distancia / 1000) * (this.consumoGasolina / 100) * this.precioGasolina;

    return {
      limpieza,
      conduccion,
      total: limpieza + conduccion,
      distancia,
      gasolina,
    };
  }

  // Métodos
  setStartLocation(place: any) {
    if (!place || !place.geometry) return;
    this.startLocation = {
      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng(),
    };
    this.startLocationName = place.name || place.formatted_address;
    this.updateCustomMarker(
      "start",
      this.startLocation,
      this.startLocationName
    );
    this.center = this.startLocation;
    this.zoom = 12;
  }

  setEndLocation(place: any) {
    if (!place || !place.geometry) return;
    this.endLocation = {
      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng(),
    };
    this.endLocationName = place.name || place.formatted_address;
    this.updateCustomMarker("end", this.endLocation, this.endLocationName);
  }

  updateCustomMarker(
    type: "start" | "end",
    position: { lat: number; lng: number },
    nombre: string
  ) {
    this.customMarkers = this.customMarkers.filter((m) => m.type !== type);
    this.customMarkers.push({
      position,
      info: {},
      nombre,
      id: type === "start" ? -1 : -2,
      type,
    });
  }

  updateSelectedCentros(e: any) {
    this.selectedCentros = e.value || [];
  }

  selectionChanged(e: any) {
    this.selectedCentros_DropDown = e.selectedRowKeys;
    this.selectedCentros = e.selectedRowKeys.map((item: any) => item.id);
  }

  getDisplayText() {
    if (!this.selectedCentros.length) return "Seleccione centros";
    const selected = this.centrosOptions.filter((c) =>
      this.selectedCentros.includes(c.id)
    );
    return selected.map((c) => c.nombre).join(", ");
  }

  formatDistance(metros: number = 0): string {
    return metros < 1000 ? `${metros} m` : `${(metros / 1000).toFixed(1)} km`;
  }

  formatTime(segundos: number = 0): string {
    const horas = Math.floor(segundos / 3600);
    const minutos = Math.floor((segundos % 3600) / 60);
    return horas > 0 ? `${horas}h ${minutos}min` : `${minutos} min`;
  }

  customMarker(type?: "start" | "end" | "center" | "hotel", color?: string) {
    let finalColor = color || "#4285F4"; // Default para centros
    const texto = UtilsString.ValueOf(color); // "1", "2", ...
    const color_fijo = "ff330000"; // azul fijo o cualquier otro que prefieras
    // Forzar color por tipo
    if (type === "start") {
      finalColor = "#43a047"; // Verde
      return {
        url: `http://maps.google.com/mapfiles/ms/icons/${this.hexToGoogleColor(
          finalColor
        )}-dot.png`,
        scaledSize: { width: 50, height: 50 },
      };
    } else if (type === "end") {
      finalColor = "#ff9900"; // Naranja
      return {
        url: `http://maps.google.com/mapfiles/ms/icons/${this.hexToGoogleColor(
          finalColor
        )}-dot.png`,
        scaledSize: { width: 50, height: 50 },
      };
    } else if (type === "hotel") {
      return {
        url: "https://maps.gstatic.com/mapfiles/place_api/icons/v1/png_71/lodging-71.png",
        scaledSize: { width: 40, height: 40 },
      };
    }

    return {
      url: `https://mt.google.com/vt/icon?text=${texto}&psize=16&font=fonts/arialuni_t.ttf&color=${color_fijo}&name=icons/spotlight/spotlight-waypoint-b.png&ax=50&ay=50&scale=1`,
      scaledSize: { width: 50, height: 50 },
    };
  }

  hexToGoogleColor(hex: string): string {
    const mapa = {
      "#1e88e5": "blue",
      "#43a047": "green",
      "#ff9900": "orange",
      "#8e24aa": "purple",
      "#fb8c00": "yellow",
      "#3949ab": "blue",
      "#d81b60": "pink",
    };
    return mapa[hex.toLowerCase() as keyof typeof mapa] || "red";
  }

  openInfoWindow(index: number) {
    const marker = this.filteredMarkers[index];
    if (marker) {
      this.infoWindowPosition = marker.position;
      this.infoWindowContent = {
        nombre: marker.nombre,
        direccion: marker.direccion,
      };
      this.infoWindowOpened = true;
    }
  }

  closeInfoWindow() {
    // this.infoWindowOpened = false;
    if (this.timeoutCerrarInfo) clearTimeout(this.timeoutCerrarInfo);

    this.timeoutCerrarInfo = setTimeout(() => {
      this.infoWindowOpened = false;
      this.timeoutCerrarInfo = null;
    }, 1500); // 1.5 segundos de retardo
  }

  toggleDayExpansion(planIndex: number, dayIndex: number) {
    const plan = this.routePlans[planIndex];
    if (plan && plan[dayIndex]) {
      plan[dayIndex].expanded = !plan[dayIndex].expanded;
    } else {
      console.warn("Índice de ruta o día inválido:", planIndex, dayIndex);
    }
  }

  async calcularRuta() {
    try {
      this.loading = true;
      this.rutaCalculada = true;
      this.routePlans = []; // Reiniciar las rutas planificadas

      // Validaciones básicas
      if (!this.startLocation) throw new Error("Seleccione un punto de inicio");
      if (!this.endLocation) throw new Error("Seleccione un punto final");
      if (!this.selectedCentros.length)
        throw new Error("Seleccione al menos un centro");

      this.routePlans.push([
        {
          day: "Día 1",
          centers: [],
          expanded: true,
        },
      ]);

      this.routePlans[0][0].centers.push({
        nombre: this.startLocationName,
        direccion: "",
        posicion: "",
        type: "start",
        lat: this.startLocation.lat,
        lng: this.startLocation.lng,
        id_centro: -1,
        colorRuta: "1",
      });
    } catch (error) {
      console.error("Error al calcular ruta:", error);
      //@ts-ignore
      this.snackbar = { show: true, text: error.message, color: "error" };
    } finally {
      this.loading = false;
    }
  }

  abrirGoogleMaps(pos: { lat: number; lng: number }) {
    const url = `https://www.google.com/maps?q=${pos.lat},${pos.lng}`;
    window.open(url, "_blank");
  }
  eliminar_dia(planIndex: number, dayIndex: number) {
    this.routePlans[planIndex].splice(dayIndex, 1);
    if (this.routePlans[planIndex].length === 0) {
      this.routePlans.splice(planIndex, 1);
    }
    // Si no quedan días, eliminar el plan
    if (this.routePlans.length === 0) {
      this.rutaCalculada = false;
    }
  }
  deleteCenter(planIndex: number, dayIndex: number, centerIndex: number) {
    this.routePlans[planIndex][dayIndex].centers.splice(centerIndex, 1);
    if (this.routePlans[planIndex][dayIndex].centers.length === 0) {
      this.routePlans[planIndex].splice(dayIndex, 1);
    }
    // Si el día queda vacío, eliminarlo
    if (this.routePlans[planIndex].length === 0) {
      this.routePlans.splice(planIndex, 1);
    }
    // Si no quedan días, eliminar el plan
    if (this.routePlans.length === 0) {
      this.rutaCalculada = false;
    }
    //Recalcular tiempos y distancias
    this.recalcularTiemposYDistancias(planIndex, dayIndex);
  }
  recalcularTiemposYDistancias(planIndex: number, dayIndex: number) {
    const centers = this.routePlans[planIndex][dayIndex].centers;
    if (centers.length === 0) return;

    for (let i = 1; i < centers.length; i++) {
      // Siempre trabajar con el objeto actualizado del array
      const previousCenter =
        this.routePlans[planIndex][dayIndex].centers[i - 1];
      const center = centers[i];
      const request = {
        id_centro: previousCenter.id_centro,
        StartLocation: { lat: previousCenter.lat, lng: previousCenter.lng },
        EndLocation: { lat: center.lat, lng: center.lng },
      };

      centrosModule.obtenerRutaGoogle(request).then((ruta: RutaCache) => {
        if (ruta) {
          // Crea un nuevo objeto para forzar reactividad
          const updated = {
            ...previousCenter,
            direccion: ruta.StartAddress + "" + ruta.DistanciaMetros,
            distanciaAlSiguiente: ruta.DistanciaMetros,
            tiempoAlSiguiente: ruta.DuracionSegundos,
            siguiente: center,
          };
          // Reemplaza el objeto en el array
          this.$set(
            this.routePlans[planIndex][dayIndex].centers,
            i - 1,
            updated
          );
        }
      });
    }
  }

  agregarDia(planIndex: number, dayIndex: number) {
    var centro_anterior =
      this.routePlans[planIndex][dayIndex].centers[
        this.routePlans[planIndex][dayIndex].centers.length - 1
      ];
    var anterior = { ...centro_anterior };

    this.routePlans[planIndex].splice(dayIndex + 1, 0, {
      day: `Día ${dayIndex + 2}`,
      centers: [],
      expanded: true,
    });

    if (anterior.type === "end") {
      anterior.type = "start";
      anterior.id_centro = -1;
      anterior.distanciaAlSiguiente = 0;
      anterior.tiempoAlSiguiente = 0;
      anterior.siguiente = undefined;
      anterior.colorRuta = (dayIndex + 2).toString();
    }
    this.routePlans[planIndex][dayIndex + 1].centers.push(anterior);
  }

  podemosAgregarDia(planIndex: number, dayIndex: number) {
    // Solo mostrar el botón en el último elemento del array de días de la ruta
    const totalDias = this.routePlans[planIndex].length;
    return dayIndex === totalDias - 1;
  }

  podemosAgregarMas(planIndex: number, dayIndex: number) {
    const centers = this.routePlans[planIndex][dayIndex].centers;

    const totalCentros = this.routePlans[planIndex][dayIndex].centers.filter(
      (c) => c.type === "center"
    ).length;

    // No contar el hotel si está en la primera posición
    const totalHoteles = centers
      .slice(1)
      .filter((c) => c.type === "hotel").length;

    const totalInicioFin = this.routePlans[planIndex][dayIndex].centers.filter(
      (c) => c.type === "end"
    ).length;

    if (totalInicioFin > 0) {
      return false; // No se pueden agregar más centros si ya hay un punto final
    }
    if (totalHoteles > 0) {
      return false; // No se pueden agregar más centros si ya hay un hotel
    }

    return totalCentros <= this.maxSelectedCenters;
  }
  agregarCentro(planIndex: number, dayIndex: number) {
    this.showindexSelected = 0;
    this.routePlan_edit = this.routePlans[planIndex][dayIndex];
    var anterior =
      this.routePlans[planIndex][dayIndex].centers[
        this.routePlans[planIndex][dayIndex].centers.length - 1
      ];
    this.HeadersAddCentro = this.HeadersDefaultCentro;
    const allCenterIds: number[] = this.routePlans
      .flat() // Aplana la matriz bidimensional
      .flatMap((plan) => plan.centers.map((center) => center.id_centro)); // Extrae los ids de los centros

    const idsNoEstanEnRuta: number[] = this.selectedCentros.filter(
      (id) => !allCenterIds.includes(id)
    );

    if (anterior.id_centro > 0) {
      this.tituloPopUp =
        "Selecciona un centro la proximidad  se calcula en relacion al centro anterior";
      const request = {
        id_centro: anterior.id_centro,
        StartLocation: { lat: anterior.lat, lng: anterior.lng },
        SelectedCentros: this.selectedCentros,
        AllCentersSelect: idsNoEstanEnRuta,
      };
      centrosModule.GetCentroACentro(request).then((response: any) => {
        if (response.error) {
          throw new Error(response.error);
        }

        this.showCentroAdd = true;
        const data = response;
        this.datosCentroAdd = data.map((item: any) => {
          const distanciaKm =
            Math.round((item.DistanciaAlSiguiente / 1000) * 100) / 100;

          const totalSeconds = item.TiempoAlSiguiente;
          const horas = Math.floor(totalSeconds / 3600);
          const minutos = Math.floor((totalSeconds % 3600) / 60);

          const duracionTexto = `${
            horas > 0 ? horas + " h " : ""
          }${minutos} min`;

          return {
            ...item,
            DistanciaKm: distanciaKm,
            DuracionHoras: horas,
            DuracionMinutos: minutos,
            DuracionTexto: duracionTexto,
          };
        });
      });
    } else {
      this.tituloPopUp =
        "Selecciona un centro cercano | Te enseñamos los 5 centros mas cercanos y los 5 mas lejanos";
      const request = {
        startLocation: { lat: anterior.lat, lng: anterior.lng },
        selectedCentros: idsNoEstanEnRuta,
      };
      // Llamar al servicio para obtener los centros cercanos
      centrosModule.Getcercanos(request).then((response: any) => {
        if (response.error) {
          throw new Error(response.error);
        }

        this.showCentroAdd = true;
        const data = response;
        this.datosCentroAdd = data.map((item: any) => {
          const distanciaKm =
            Math.round((item.DistanciaAlSiguiente / 1000) * 100) / 100;

          const totalSeconds = item.TiempoAlSiguiente;
          const horas = Math.floor(totalSeconds / 3600);
          const minutos = Math.floor((totalSeconds % 3600) / 60);

          const duracionTexto = `${
            horas > 0 ? horas + " h " : ""
          }${minutos} min`;

          return {
            ...item,
            DistanciaKm: distanciaKm,
            DuracionHoras: horas,
            DuracionMinutos: minutos,
            DuracionTexto: duracionTexto,
          };
        });
      });
    }
  }
  agregarHotel(planIndex: number, dayIndex: number) {
    this.showindexSelected = 1;
    this.routePlan_edit = this.routePlans[planIndex][dayIndex];
    var anterior =
      this.routePlans[planIndex][dayIndex].centers[
        this.routePlans[planIndex][dayIndex].centers.length - 1
      ];
    this.HeadersAddCentro = this.HeadersDefaultHotel;
    const request = {
      id_centro: anterior.id_centro,
      StartLocation: { lat: anterior.lat, lng: anterior.lng },
      SelectedCentros: this.selectedCentros,
    };

    centrosModule.GetHotelesCercanos(request).then((response: any) => {
      if (response.error) {
        throw new Error(response.error);
      }

      this.showCentroAdd = true;
      const data = response;
      this.datosCentroAdd = data.map((item: any) => {
        const distanciaKm =
          Math.round((item.ruta.DistanciaMetros / 1000) * 100) / 100;

        const totalSeconds = item.ruta.DuracionSegundos;
        const horas = Math.floor(totalSeconds / 3600);
        const minutos = Math.floor((totalSeconds % 3600) / 60);

        const duracionTexto = `${horas > 0 ? horas + " h " : ""}${minutos} min`;

        return {
          ...item,
          DistanciaKm: distanciaKm,
          DuracionHoras: horas,
          DuracionMinutos: minutos,
          DuracionTexto: duracionTexto,
        };
      });
    });
  }
  volverCasa(planIndex: number, dayIndex: number) {
    this.routePlan_edit = this.routePlans[planIndex][dayIndex];
    this.showindexSelected = 2;
    var anterior =
      this.routePlan_edit.centers[this.routePlan_edit.centers.length - 1];
    var home: PuntoRuta = {
      nombre: this.startLocationName,
      direccion: "",
      posicion: this.endLocation!.lat! + "," + this.endLocation!.lng!,
      type: "end",
      lat: this.endLocation!.lat!,
      lng: this.endLocation!.lng!,
      id_centro: -1,
    };
    const request = {
      id_centro: anterior.id_centro,
      StartLocation: { lat: anterior.lat, lng: anterior.lng },
      EndLocation: { lat: home.lat, lng: home.lng },
    };

    centrosModule.obtenerRutaGoogle(request).then((ruta: RutaCache) => {
      if (ruta) {
        anterior.distanciaAlSiguiente = ruta.DistanciaMetros;
        anterior.tiempoAlSiguiente = ruta.DuracionSegundos;
        const nuevoCentro: PuntoRuta = {
          nombre: this.endLocationName,
          direccion: ruta.EndAddress,
          posicion: home.posicion,
          type: home.type,
          lat: home.lat,
          lng: home.lng,
          distanciaAlSiguiente: ruta.DistanciaMetros,
          tiempoAlSiguiente: ruta.DuracionSegundos,
          id_centro: home.id_centro,
        };
        anterior.siguiente = nuevoCentro;
        this.routePlans[planIndex][dayIndex].centers.push(nuevoCentro);
      }
    });
  }
  onRowAddCentroSelected(selectedRow: any) {
    var anterior =
      this.routePlan_edit.centers[this.routePlan_edit.centers.length - 1];

    switch (this.showindexSelected) {
      case 0:
        var nuevoCentro = this.AddCentro(anterior, selectedRow);
        this.routePlan_edit.centers.push(nuevoCentro);
        break;
      case 1:
        var nuevoCentro = this.AddHotel(anterior, selectedRow);
        this.routePlan_edit.centers.push(nuevoCentro);
        break;
      case 2:
        break;
    }
  }
  AddHotel(anterior: PuntoRuta, selectedRow: any) {
    anterior.siguiente = {
      nombre: selectedRow.Nombre,
      direccion: selectedRow.Direccion,
      posicion: selectedRow.Lat + "," + selectedRow.Lng,
      type: "hotel",
      lat: selectedRow.Lat,
      lng: selectedRow.Lng,
      id_centro: selectedRow.IdCentro,
    };
    anterior.distanciaAlSiguiente = selectedRow.ruta.DistanciaMetros;
    anterior.tiempoAlSiguiente = selectedRow.ruta.DuracionSegundos;
    this.routePlan_edit.hotel = selectedRow;
    const nuevoCentro: PuntoRuta = {
      nombre: selectedRow.Nombre,
      direccion: selectedRow.Direccion,
      posicion: selectedRow.Lat + "," + selectedRow.Lng,
      type: "hotel",
      lat: selectedRow.Lat,
      lng: selectedRow.Lng,
      id_centro: selectedRow.IdCentro,
    };
    return nuevoCentro;
  }
  AddCentro(anterior: PuntoRuta, selectedRow: any) {
    anterior.siguiente = {
      nombre: selectedRow.Nombre,
      direccion: selectedRow.Direccion,
      posicion: selectedRow.Lat + "," + selectedRow.Lng,
      type: "center",
      lat: selectedRow.Lat,
      lng: selectedRow.Lng,
      id_centro: selectedRow.IdCentro,
    };
    anterior.distanciaAlSiguiente = selectedRow.DistanciaAlSiguiente;
    anterior.tiempoAlSiguiente = selectedRow.TiempoAlSiguiente;
    if (
      anterior.direccion == null ||
      UtilsString.IsNullOrWhiteSpace(anterior.direccion)
    ) {
      anterior.direccion = selectedRow.StartAddress;
    }
    const nuevoCentro: PuntoRuta = {
      nombre: selectedRow.Nombre,
      direccion: selectedRow.Direccion,
      posicion: selectedRow.Lat + "," + selectedRow.Lng,
      type: "center",
      lat: selectedRow.Lat,
      lng: selectedRow.Lng,
      id_centro: selectedRow.IdCentro,
      colorRuta: anterior.colorRuta,
    };
    return nuevoCentro;
  }

  OpenEditForm() {
    // Validar que el ID no sea nulo o vacío
    if (UtilsString.IsNullOrWhiteSpace(this.$route.params.id)) {
      return;
    }
    if (!UtilsString.IsValidParamUrl(this.$route.params.id)) {
      return;
    }
    var id = Number.parseInt(UtilsString.ValueOf(this.$route.params.id));
    if (isNaN(id)) {
      return;
    }

    centrosModule.GetRuta(id).then((res: any) => {
      if (res) {
        const data = res;
        this.planificacion_nombre = data.planificacion.nombre;
        this.routePlans = data.Planes.map((ruta: any[], index: number) =>
          ruta.map((dia: any) => {
            return {
              day: dia.Dia,
              tiempoTotalDia: dia.TiempoTotalDia,
              Hotel: dia.Hotel,
              centers: dia.Centros.map((centro: any) => ({
                nombre: centro.Nombre,
                direccion: centro.Direccion,
                lat: centro.Lat,
                lng: centro.Lng,
                posicion: {
                  lat: centro.Lat,
                  lng: centro.Lng,
                },
                id_centro: centro.IdCentro,
                distanciaAlSiguiente: centro.DistanciaAlSiguiente,
                tiempoAlSiguiente: centro.TiempoAlSiguiente,
                type: centro.Tipo,
                siguiente: centro.Siguiente || null,
                colorRuta: index + 1, //colorRuta || null,
              })),
              /* rutaTiempos: {
                distanciaTotal: dia.rutaTiempos.DistanciaTotal,
                tiempoTotal: dia.rutaTiempos.TiempoTotal,
                tiempoLimpiezaTotal: dia.rutaTiempos.TiempoLimpiezaTotal,
                costoGasolina: dia.rutaTiempos.CostoGasolina,
              },*/
              expanded: false, // estado inicial en Vue
            };
          })
        );

        //Recogemos todos los centros de la ruta
        const allCenterIds: number[] = this.getAllCentersFromRoutePlans().map(
          (center) => center.id_centro
        ); // Extrae los ids de los centros
        this.selectedCentros = allCenterIds;

        this.selectedCentros_DropDown = centrosModule.centroses.filter((c) =>
          this.selectedCentros.includes(c.id)
        );

        //Recogemos inicio y fin
        const { starts, ends } = this.buscarStartYEndEnRoutePlans();

        this.startLocation = {
          lat: starts.length > 0 ? starts[0].lat : 39.2638755,
          lng: starts.length > 0 ? starts[0].lng : -0.4702895,
        };
        this.endLocation = {
          lat: ends.length > 0 ? ends[0].lat : 39.2638755,
          lng: ends.length > 0 ? ends[0].lng : -0.4702895,
        };
        this.startLocationName = starts.length > 0 ? starts[0].nombre : "";
        this.endLocationName = ends.length > 0 ? ends[0].nombre : "";

        this.rutaCalculada = true;
        this.setStartLocation(this.startLocation);
        this.setEndLocation(this.endLocation);
      }
    });
  }

  getAllCentersFromRoutePlans(): PuntoRuta[] {
    const centers: PuntoRuta[] = [];
    for (const plan of this.routePlans) {
      for (const day of plan) {
        for (const center of day.centers) {
          if (center.type === "center") {
            centers.push(center);
          }
        }
      }
    }
    return centers;
  }

  buscarStartYEndEnRoutePlans(): { starts: PuntoRuta[]; ends: PuntoRuta[] } {
    const starts: PuntoRuta[] = [];
    const ends: PuntoRuta[] = [];

    for (const plan of this.routePlans) {
      for (const day of plan) {
        for (const center of day.centers) {
          if (center.type === "start") {
            starts.push(center);
          }
          if (center.type === "end") {
            ends.push(center);
          }
        }
      }
    }

    return { starts, ends };
  }

  EstamosEnEditarRuta() {
    return this.$route.params.id !== undefined;
  }

  GuardarRuta() {
    // Implementar la lógica para guardar la ruta
    const planesParaGuardar = this.routePlans.map(
      (semana: DayPlan[], indexSemana: number) => {
        return semana.map((dia: DayPlan) => {
          return {
            Dia: dia.day,
            TiempoTotalDia: dia.tiempoTotalDia,
            Hotel: dia.hotel,
            Centros: dia.centers.map((centro: any) => {
              return {
                Nombre: centro.nombre,
                Direccion: centro.direccion,
                Lat: centro.lat,
                Lng: centro.lng,
                IdCentro: centro.id_centro,
                DistanciaAlSiguiente: centro.distanciaAlSiguiente,
                TiempoAlSiguiente: centro.tiempoAlSiguiente,
                Tipo: centro.type,
                Siguiente: centro.siguiente || null,
              };
            }),
          };
        });
      }
    );

    // si es actualizar
    if (this.$route.params.id) {
      // Validar que el ID no sea nulo o vacío
      if (UtilsString.IsNullOrWhiteSpace(this.$route.params.id)) {
        return;
      }
      if (!UtilsString.IsValidParamUrl(this.$route.params.id)) {
        return;
      }
      var id = Number.parseInt(UtilsString.ValueOf(this.$route.params.id));
      if (isNaN(id)) {
        return;
      }
      centrosModule
        .UpdateRuta({
          RutaCalculada: this.rutaCalculada,
          rutaTiempos: null,
          Planes: planesParaGuardar,
          planificacion: {
            nombre: this.planificacion_nombre,
            id: this.$route.params.id,
          },
        })
        .then((response: any) => {
          if (response.error) {
            throw new Error(response.error);
          }
          this.snackbar = {
            show: true,
            text: "Ruta guardada correctamente",
            color: "success",
          };
        });
    } else {
      // Guardar como nueva ruta
      centrosModule
        .GuardarRuta({
          RutaCalculada: this.rutaCalculada,
          rutaTiempos: null,
          Planes: planesParaGuardar,
          planificacion: {
            nombre: this.planificacion_nombre,
            id: 0,
          },
        })
        .then((response: any) => {
          if (response.error) {
            throw new Error(response.error);
          }
          this.snackbar = {
            show: true,
            text: "Ruta guardada correctamente",
            color: "success",
          };
        });
    }
  }

  descargarExcel() {
    // Validar que el ID no sea nulo o vacío
    if (UtilsString.IsNullOrWhiteSpace(this.$route.params.id)) {
      return;
    }
    if (!UtilsString.IsValidParamUrl(this.$route.params.id)) {
      return;
    }
    var id = Number.parseInt(UtilsString.ValueOf(this.$route.params.id));
    if (isNaN(id)) {
      return;
    }
    centrosModule
      .ExportarExcelGuardado(id)
      .then((response: boolean) => {
        if (!response) {
          throw new Error("Error al exportar el Excel");
        }
        this.snackbar = {
          show: true,
          text: "Ruta descargada correctamente",
          color: "success",
        };
      })
      .catch((error: any) => {
        console.error("Error al descargar el Excel:", error);
        this.snackbar = {
          show: true,
          text: "Error al descargar el Excel",
          color: "error",
        };
      });
  }

  public showCentroAdd = false;
  public showindexSelected = 0;
  public datosCentroAdd = [];
  public HeadersAddCentro = [{ text: "ID", value: "id" }];
  public HeadersDefaultCentro = [
    { text: "ID", value: "id" },
    { text: "Nombre", value: "Nombre" },
    { text: "Direccion", value: "Direccion" },
    { text: "Distancia", value: "DistanciaKm" },
    { text: "Duración", value: "DuracionTexto" },
  ];
  public HeadersDefaultHotel = [
    { text: "ID", value: "id" },
    { text: "Nombre", value: "Nombre" },
    { text: "Direccion", value: "Direccion" },
    { text: "Rating", value: "Rating" },
    { text: "Telefono", value: "Telefono" },
    { text: "SitioWeb", value: "SitioWeb" },
    { text: "Distancia", value: "DistanciaKm" },
    { text: "Duración", value: "DuracionTexto" },
  ];

  public editandoNombre: boolean = false;
}
